import { Injectable, Optional } from '@angular/core';
import { AbstractApiController } from './abstract-api-controller';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../configuration';
import { DefaultResponseInterface } from '../model/response/default-response.interface';
import { ProgramFeeConfigListResponseInterface } from '../model/response/program-fee-config-list-response.interface';
import { ProgramFeesConfigRequest } from '../model/request/program-fees-config.request';

@Injectable()
export class AdminProgramFeeApi extends AbstractApiController {

  constructor(
    private http: HttpClient,
    @Optional() config?: Configuration
  ) {
    super();
    this.baseUrl = (config && config.apiBaseUrl)
      ? config.apiBaseUrl : 'https://example.com';
  }

  public fetchList(
    filter,
    page,
    limit
  ) {
    return this.http.get<ProgramFeeConfigListResponseInterface>(
      this.prepareListRequest(
        this.baseUrl + `/api/cf/administration/program-fee-configs`,
        page,
        limit,
        [{id: 'DESC'}],
        filter
      ),
      {headers: this.getAuthHeaders()}
    );
  }

  public saveIndividualFees(request: ProgramFeesConfigRequest) {
    return this.http.post<DefaultResponseInterface>(
      this.baseUrl + `/api/cf/administration/program-fee-configs`,
      request,
      {headers: this.getAuthHeaders()}
    );
  }

  public updateIndividualFees(id: number, request: ProgramFeesConfigRequest) {
    return this.http.put<DefaultResponseInterface>(
      this.baseUrl + `/api/cf/administration/program-fee-configs/${id}`,
      request,
      {headers: this.getAuthHeaders()}
    );
  }

  public deleteIndividualFees(id: number) {
    return this.http.delete<DefaultResponseInterface>(
      this.baseUrl + `/api/cf/administration/program-fee-configs/${id}`,
      {headers: this.getAuthHeaders()}
    );
  }
}
